
import { StateSlice } from '@/stores/appStore';
import { GuidesScene } from './guideSlice';
// import { toast } from 'react-hot-toast';

const namespace = 'runtime';
export type RuntimeSlice = {
  [namespace]: {
    sidebar: {
      collapsed: boolean;
      setCollapsed: (collapsed: boolean) => void;
    };
    helpPopup: {
      open: boolean;
      isOpen: boolean;
      scene: GuidesScene | null;
      setOpen: (open: boolean, scene?: GuidesScene) => void;
      setIsOpen: (isOpen: boolean) => void;
    };
  }
};

export const createRuntimeSlice: StateSlice<RuntimeSlice> = ((set, _get) => {
  const get = () => _get()[namespace];
  return {
    [namespace]: {
      sidebar: {
        collapsed: false,
        setCollapsed: (collapsed) => {
          set(({ [namespace]: state }) => {
            state.sidebar.collapsed = collapsed;
          });
        },
      },
      helpPopup: {
        open: false,
        isOpen: false,
        scene: null,
        setOpen: (open, scene) => {
          set(({ [namespace]: state }) => {
            state.helpPopup.open = open;
            if (scene) {
              state.helpPopup.scene = scene;
            }
          });
        },
        setIsOpen: (isOpen) => {
          set(({ [namespace]: state }) => {
            state.helpPopup.isOpen = isOpen;
          });
        },
      },
    },
  };
});
